/**
 * Teens Insta Slider — Instagram follow slider ONLY
 * -------------------------------------------------
 * Selectors used by this file (unique to this section):
 *   [data-teens-insta-section]
 *   [data-insta-slider]   — root wrap
 *   [data-insta-swiper]   — .swiper element
 *   [data-insta-prev]
 *   [data-insta-next]
 *   [data-insta-pagination]
 *
 * theme.liquid (Swiper CDN already there):
 *   <script src="{{ 'prod-slider.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  var ROOT = '[data-insta-slider]';
  var READY = 'data-insta-slider-ready';
  var retries = 0;

  function toNumber(value, fallback) {
    var n = Number(value);
    return isFinite(n) && n > 0 ? n : fallback;
  }

  // Keep a small peek so arrows/swipe still work when cards fit exactly
  function slidesWithPeek(desired, slideCount) {
    if (slideCount <= 1) return 1;
    if (slideCount <= desired) return Math.max(1.2, slideCount - 0.25);
    return desired;
  }

  function initOne(root) {
    if (!root || root.getAttribute(READY) === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var slider = root.querySelector('[data-insta-swiper]');
    if (!slider) return;

    if (slider.swiper && !slider.swiper.destroyed) {
      slider.swiper.destroy(true, true);
    }

    var slideCount = slider.querySelectorAll('.swiper-slide').length;
    var desktopSlides = toNumber(root.getAttribute('data-desktop-slides'), 5);
    var desktopGap = toNumber(root.getAttribute('data-desktop-gap'), 12);
    var mobileSlides = slidesWithPeek(2.2, slideCount);
    var tabletSlides = slidesWithPeek(3.2, slideCount);
    var desktopView = slidesWithPeek(desktopSlides, slideCount);

    new Swiper(slider, {
      direction: 'horizontal',
      effect: 'slide',
      slidesPerView: mobileSlides,
      slidesPerGroup: 1,
      spaceBetween: 12,
      speed: 500,
      loop: false,
      rewind: true,
      watchOverflow: false,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      navigation: {
        nextEl: root.querySelector('[data-insta-next]'),
        prevEl: root.querySelector('[data-insta-prev]'),
      },
      pagination: {
        el: root.querySelector('[data-insta-pagination]'),
        clickable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: tabletSlides,
          spaceBetween: desktopGap,
        },
        990: {
          slidesPerView: desktopView,
          spaceBetween: desktopGap,
        },
      },
    });

    root.setAttribute(READY, 'true');
  }

  function initAll(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    var roots = parent.querySelectorAll(ROOT);

    if (scope && scope.matches && scope.matches(ROOT)) {
      initOne(scope);
    }

    Array.prototype.forEach.call(roots, initOne);
  }

  function destroyIn(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var roots = scope.querySelectorAll(ROOT);

    Array.prototype.forEach.call(roots, function (root) {
      var slider = root.querySelector('[data-insta-swiper]');
      if (slider && slider.swiper && !slider.swiper.destroyed) {
        slider.swiper.destroy(true, true);
      }
      root.removeAttribute(READY);
    });
  }

  function boot() {
    if (typeof Swiper === 'undefined') {
      if (retries < 60) {
        retries += 1;
        setTimeout(boot, 50);
      }
      return;
    }
    retries = 0;
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) return;

    var roots = target.querySelectorAll ? target.querySelectorAll(ROOT) : [];
    Array.prototype.forEach.call(roots, function (root) {
      root.removeAttribute(READY);
    });
    if (target.matches && target.matches(ROOT)) {
      target.removeAttribute(READY);
    }
    initAll(target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target);
  });
})();
